"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
const CheckBoxOutlineBlankSharp_1 = __importDefault(require("@material-ui/icons/CheckBoxOutlineBlankSharp"));
const CheckBoxSharp_1 = __importDefault(require("@material-ui/icons/CheckBoxSharp"));
const IndeterminateCheckBoxSharp_1 = __importDefault(require("@material-ui/icons/IndeterminateCheckBoxSharp"));
const auto_focus_hook_1 = require("../../utils/auto-focus-hook");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const checkbox_styles_1 = require("./checkbox-styles");
function Checkbox({ form, value, onChange, disabled, threeState, icon: defaultIcon, checkedIcon: defaultCheckedIcon, highlighted = true, autoFocus, }) {
    // fix undefined value
    value = value !== null && value !== void 0 ? value : null;
    const [action, setAction] = (0, react_1.useState)();
    const handleAction = (0, event_callback_hook_1.useEventCallback)((instance) => {
        if (instance) {
            setAction(instance);
        }
    });
    // prepare value for MUI component
    const indeterminate = threeState ? value === null : false;
    value = !!value;
    const handleChange = (0, event_callback_hook_1.useEventCallback)((e) => {
        onChange(e.target.checked);
    });
    const handleClick = (0, event_callback_hook_1.useEventCallback)((e) => {
        e.stopPropagation();
    });
    const { root, highlightedIcon, ...classes } = (0, checkbox_styles_1.useStyles)();
    const { autoFocusRef } = (0, auto_focus_hook_1.useAutoFocus)(autoFocus, disabled);
    const icon = defaultIcon || (react_1.default.createElement(CheckBoxOutlineBlankSharp_1.default, { className: (0, clsx_1.default)({ [highlightedIcon]: !disabled && highlighted }) }));
    const checkedIcon = defaultCheckedIcon || (react_1.default.createElement(CheckBoxSharp_1.default, { className: (0, clsx_1.default)({ [highlightedIcon]: !disabled && highlighted }) }));
    return (react_1.default.createElement(Checkbox_1.default, { classes: {
            root,
            ...classes,
        }, inputProps: {
            form,
        }, inputRef: autoFocusRef, action: handleAction, onFocus: () => {
            var _a;
            (_a = autoFocusRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            action === null || action === void 0 ? void 0 : action.focusVisible();
        }, indeterminate: indeterminate, disabled: disabled, checked: value, color: "primary", onChange: handleChange, onClick: handleClick, icon: icon, checkedIcon: checkedIcon, indeterminateIcon: react_1.default.createElement(IndeterminateCheckBoxSharp_1.default, null) }));
}
exports.Checkbox = Checkbox;
//# sourceMappingURL=checkbox.js.map